export function getExplicitMatchCoordinates(match) {
  const isCoordinate = (value) =>
    (typeof value === "number" || typeof value === "string") && String(value).trim() !== "";
  if (!isCoordinate(match?.latitude) || !isCoordinate(match?.longitude)) return null;

  const latitude = Number(match.latitude);
  const longitude = Number(match.longitude);
  if (!Number.isFinite(latitude) || !Number.isFinite(longitude) ||
      Math.abs(latitude) > 90 || Math.abs(longitude) > 180) return null;

  return { latitude, longitude };
}

export function getMatchAddress(match) {
  const clean = value => typeof value === "string" ? value.trim().replace(/\s+/g, " ") : "";
  const street = clean(match?.rangeAddress);
  if (!street) return "";
  return [...new Set([street, clean(match.city), clean(match.state), clean(match.postalCode), clean(match.country)].filter(Boolean))].join(", ");
}

export function isAddressLocation(match) {
  return !getExplicitMatchCoordinates(match) && match?.mapLocation?.source === "address"
    && match.mapLocation.query === getMatchAddress(match).toLowerCase()
    && Boolean(getExplicitMatchCoordinates(match.mapLocation));
}

export function getMatchCoordinates(match) {
  return getExplicitMatchCoordinates(match) || (isAddressLocation(match) ? getExplicitMatchCoordinates(match.mapLocation) : null);
}
